/**
 * レイアウト
 * ページレイアウト、コンテナ、z-indexなどの構造的な定義
 *
 * このファイルには以下のカテゴリが含まれます：
 * - コンテンツ幅: コンテンツエリアの最大幅
 * - フォーム幅: フォーム入力エリアの最適幅
 * - PDFビューワー幅: PDF表示エリアの設定
 * - ヘッダー・フッター: ヘッダーとフッターのサイズ
 * - サイドバー: サイドバーの幅
 * - Z-index階層: 要素の重なり順序
 * - コンテナ設定: コンテナのパディング
 */

/**
 * レイアウト - 柔軟で使いやすいレイアウトシステム
 */
export const LAYOUT = {
  contentWidth: {
    xs: '100%',
    sm: '540px',
    md: '720px',
    lg: '960px',
    xl: '1140px',
    '2xl': '1320px',
    // 従来との互換性
    min: '280px',
    max: '1140px',
  },

  // フォーム入力エリアの最適幅（3:7比率用）
  formWidth: {
    min: '320px',
    optimal: '360px', // 3:7比率に最適化
    max: '450px', // 最大幅を調整
  },

  // PDF表示エリアの設定
  pdfViewerWidth: {
    ratio: '70%', // 7/10の比率
    minWidth: '500px', // 最小表示幅
  },

  // ヘッダー・フッターサイズ
  headerHeight: {
    mobile: '56px',
    desktop: '64px',
  },
  footerHeight: '80px',

  // サイドバー
  sidebarWidth: {
    collapsed: '60px',
    expanded: '280px',
  },

  // Z-index階層
  zIndex: {
    hide: -1,
    auto: 'auto',
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800,
  },

  // コンテナ設定
  container: {
    padding: {
      mobile: '16px',
      tablet: '24px',
      desktop: '32px',
    },
  },
} as const;
